import { library } from "@fortawesome/fontawesome-svg-core";
import {fab, faXing, faLinkedinIn, faYoutube, faFacebookF, faInstagram} from "@fortawesome/free-brands-svg-icons";

function initFontAwesome() {
    library.add(fab, faYoutube, faFacebookF, faLinkedinIn, faInstagram, faXing);
}
export default initFontAwesome;
